type QueryScopeUser = { tenant_id?: string; impersonated_tenant_id?: string } | null | undefined

/**
 * Cache scope for tenant-owned client data. Impersonation swaps the effective
 * tenant without remounting the QueryClient, so it must be part of the key.
 */
export function getQueryTenantId(user: QueryScopeUser): string {
  return user?.impersonated_tenant_id ?? user?.tenant_id ?? "unauthenticated"
}
